export default function AuthSkeleton() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="w-full max-w-md rounded-2xl bg-surface-1 border border-border/50 p-8 space-y-6">
        <div className="h-8 w-48 mx-auto bg-surface-2 rounded-lg animate-pulse" />
        
        <div className="space-y-4">
          <div className="space-y-2">
            <div className="h-4 w-20 bg-surface-2 rounded-lg animate-pulse" />
            <div className="h-10 w-full bg-surface-2 rounded-lg animate-pulse" />
          </div>
          <div className="space-y-2">
            <div className="h-4 w-20 bg-surface-2 rounded-lg animate-pulse" />
            <div className="h-10 w-full bg-surface-2 rounded-lg animate-pulse" />
          </div>
          <div className="h-12 w-full bg-brand-glow/20 rounded-lg animate-pulse" />
        </div>
        
        <div className="h-4 w-48 mx-auto bg-surface-2 rounded-lg animate-pulse" />
      </div>
    </div>
  );
}
